export const SHOPPING_CART_STEPS = {
  SHOPPING_CART: 1,
  PAYMENT_PROGRESS: 2,
  PAYMENT_COMPLETED: 3,
};